export default __webpack_public_path__ + "static/media/price_alert.f160017e.svg";